import React, { useState } from 'react';
import { useObserver } from 'mobx-react';
import PropTypes from 'prop-types';

import { PdfWrapper } from 'libs/rendering/styles';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export function PDFViewer({ file, width, isPreview = false }) {
  // TODO - support page lazy-loading
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess(pdf) {
    setNumPages(pdf.numPages);
  }

  return useObserver(() => (
    <>
      <PdfWrapper isPreview={isPreview} width={width}>
        <Document file={file?.url} onLoadSuccess={onDocumentLoadSuccess}>
          {[...Array(numPages).keys()].map(i => (
            <Page key={i} pageNumber={i + 1} width={816} height={1056} />
          ))}
        </Document>
      </PdfWrapper>
    </>
  ));
}

PDFViewer.propTypes = {
  file: PropTypes.object,
  isPreview: PropTypes.bool,
  width: PropTypes.string,
};
